<template>
  <div id="app">
    <AppNav />
    <AppLiveStream />
    <AppLiveStreamInfo />
    <AppBillboard />
    <LocationIndexList :collapse-id="locationsListCollapse" />
    <GenresIndexList :collapse-id="genresListCollapse" :genres="$store.getters.getGenres" />
    <GenresIndexList :collapse-id="subjectsListCollapse" :genres="$store.getters.getSubjects" :is-subject="true" :collapse-visible="true" />
    <GenresInfo :collapse-id="genresInfoCollapse" />
    <div id="mvmnt-wrapper">
      <transition
        :duration="300"
        @before-leave="beforeLeave"
        @after-leave="afterLeave"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
        @leave="leave"
        @enter="enter"
      >
        <KeepAlive>
          <router-view :key="$route.path" />
        </KeepAlive>
      </transition>
    </div>
    <AppFooter v-show="isRouteFinished" />
    <Cookies />
    <Popup>
      <template>
        <p>Movement symbolizes change. Stegi represents the idea of home as an open space for dialogue and interaction</p>
        <p>movement.radio is now stegi.radio</p>
        <p>Turn the volume up</p>
      </template>
    </Popup>
    <Error404 v-if="isError" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AppNav from '@/components/header/AppNav.vue';
import AppLiveStream from '@/components/header/AppLiveStream.vue';
import AppLiveStreamInfo from '@/components/header/AppLiveStreamInfo.vue';
import LocationIndexList from "@/components/location/LocationIndexList";
import AppFooter from '@/components/AppFooter.vue';
import Cookies from '@/components/Cookies';
import Error404 from '@/components/errorHandlers/Error404.vue';
import GenresIndexList from "@/components/genres/GenresIndexList";
import GenresInfo from "@/components/genres/GenresInfo";
import Popup from "@/components/Popup.vue";
import AppBillboard from "@/components/header/AppBillboard.vue";
import SoundcloudPlayer from "@/components/players/SoundcloudPlayer/SoundcloudPlayer";
export default {
  name: 'App',
  components: {
    Popup,
    AppNav,
    AppLiveStream,
    AppLiveStreamInfo,
    Cookies,
    AppFooter,
    Error404,
    LocationIndexList,
    GenresIndexList,
    GenresInfo,
    AppBillboard
  },
  data() {
    return {
      colorBar: '#1684FC',
      errored: false,
      isMounted: false,
      isRouteFinished: false,
      locationsListCollapse: 'location-index-collapse',
      genresListCollapse: 'genres-index-collapse',
      subjectsListCollapse: 'subjects-index-collapse',
      genresInfoCollapse: 'genres-info-collapse'
    };
  },
  computed: {
    ...mapState({
      error: state => state.error,
      isError(state) {
        return Object.keys(state.error).length > 0;
      }
    })
  },
  mounted() {
    SoundcloudPlayer.define('snd-player');

    setTimeout(() => {
        this.isRouteFinished = true;
    }, 500);

    this.$router.beforeEach((to, from, next) => {
      this.$store.dispatch('resetErrorState');
      next();
    });

    this.$store.dispatch('setGenresState'); // API call runs only once at the app mount
  },

  methods: {
    beforeLeave() {
      this.isRouteFinished = false;
    },
    leave(el, done) {
      // el.classList.add('fade-out');
      done();
    },
    afterLeave(el) {
      // el.classList.add('fade-out-fast');
      // this.$root.$emit('inhalt');
    },
    beforeEnter(el) {
      // el.classList.remove('fade-out-fast');
      // el.classList.add('fade-in');
    },
    enter(el, done) {
      // disable
      // el.classList.remove('fade-out');
      // el.classList.add('fade-in');
      done();
    },
    afterEnter() {
      setTimeout(() => {
        this.isRouteFinished = true;
      }, 500);

      this.$root.$emit('trigger-scroll');
    }
  }
};
</script>
